import React, {
  useEffect,
  useState,
  useContext,
  createContext,
  useRef,
} from "react";
import { useTranslation, Trans } from "react-i18next";
import { Button, FormHelperText, Box } from "@mui/material";
import PhonePage from "./PhonePage";
import GamePage from "./GamePage";
import InfomationPage from "./InfomationPage";
import ThankYouPage from "./ThankYouPage";
import ImeiPage from "./ImeiPage";
import { Unstable_Popup as BasePopup } from "@mui/base/Unstable_Popup";
import ProductTable from "../components/ProductTable";
import useMediaQuery from "@mui/material/useMediaQuery";
import EndPage from "./EndPage";
export const FormContext = createContext();

const Form = () => {
  const { t, i18n } = useTranslation();
  const [currentStep, setCurrentStep] = useState(4);
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [imeiChance, setImeiChange] = useState(0);
  const dataValue = {
    currentStep,
    setCurrentStep,
    data,
    setData,
    isLoading,
    setIsLoading,
    imeiChance,
    setImeiChange,
  };

  const handleSwitchLang = (lang) => {
    i18n.changeLanguage(lang);
    localStorage.setItem("lang", lang);
  };

  const [anchor, setAnchor] = React.useState(null);
  const popupRef = useRef(null); // Create a ref for the popup

  const handleClick = (event) => {
    setAnchor(anchor ? null : event.currentTarget);
  };
  const handleClickOutside = (event) => {
    // Check if the click is outside the popup
    if (
      popupRef.current &&
      !popupRef.current.contains(event.target) &&
      anchor
    ) {
      setAnchor(null); // Close the popup
    }
  };

  const open = Boolean(anchor);
  const id = open ? "simple-popper" : undefined;

  useEffect(() => {
    // Add event listener for clicks
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Clean up the event listener on unmount
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [anchor]);

  const matches = useMediaQuery("(min-width:840px)");

  return (
    <FormContext.Provider value={dataValue}>
      <Box sx={{ maxWidth: 800, margin: " auto" }}>
        {matches && i18n.language == "hk" && currentStep != 1 ? (
          <img width={"100%"} src={`assets/img/desktop_tc.jpg`} />
        ) : !matches && i18n.language == "hk" && currentStep != 1 ? (
          <img width={"100%"} src={`assets/img/mobile_tc.jpg`} />
        ) : matches && i18n.language == "hk_en" && currentStep != 1 ? (
          <img width={"100%"} src={`assets/img/desktop_en.jpg`} />
        ) : !matches && i18n.language == "hk_en" && currentStep != 1 ? (
          <img width={"100%"} src={`assets/img/mobile_en.jpg`} />
        ) : (
          <></>
        )}
      </Box>
      <Box sx={{ maxWidth: 800, margin: "30px auto", padding: "0 40px" }}>
        {currentStep === 0 ? (
          <FormHelperText
            sx={{ fontSize: "18px", marginBottom: "20px", textAlign: "center" }}
          >
            {i18n.language == "hk" ? (
              <div>
                請輸入你所購買的
                <span
                  onClick={handleClick}
                  style={{ textDecoration: "underline" }}
                >
                  Galaxy指定產品
                </span>
                的IMEI/SN編號，我們會根據你所購買的指定產品種類而分配答題機會次數給你！
              </div>
            ) : (
              <div>
                Please enter the{" "}
                <span
                  onClick={handleClick}
                  style={{ textDecoration: "underline" }}
                >
                  eligible Galaxy Product's
                </span>{" "}
                IMEI / SN that you have purchased. We will base on the eligible
                products purchased to allocate the number of chances to answer!
              </div>
            )}
          </FormHelperText>
        ) : (
          <></>
        )}
        <Box sx={{ position: "absolute" }}>
          <BasePopup id={id} open={open} anchor={anchor} ref={popupRef}>
            <ProductTable />
          </BasePopup>
        </Box>
        {currentStep == 0 || currentStep == 2 ? (
          <Box sx={{ height: 50 }}>
            <FormHelperText sx={{ textAlign: "center" }}>
              <Trans i18nKey="global:marked" />
            </FormHelperText>
          </Box>
        ) : (
          <></>
        )}
        {currentStep === 0 ? (
          <PhonePage />
        ) : currentStep === 1 ? (
          <GamePage />
        ) : currentStep === 2 ? (
          <InfomationPage />
        ) : currentStep === 3 ? (
          <ThankYouPage />
        ) : currentStep === 4 ? (
          <EndPage />
        ) : (
          <></>
        )}
        {/* <Box sx={{marginTop:"20px"}}>
          {i18n.language == "hk" ? (
            <Button
              onClick={() => handleSwitchLang("hk_en")}
              variant="outlined"
            >
              English
            </Button>
          ) : (
            <Button onClick={() => handleSwitchLang("hk")} variant="outlined">
              繁體中文
            </Button>
          )}
        </Box> */}
      </Box>
    </FormContext.Provider>
  );
};

export default Form;
